import { render, staticRenderFns } from "./Competition.vue?vue&type=template&id=4cdaabff&scoped=true&"
var script = {}
import style0 from "./Competition.vue?vue&type=style&index=0&id=4cdaabff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdaabff",
  null
  
)

export default component.exports